const getSearchAddFilter = (
	config = {
		addTextKey: "",
		addIcon: "",
		hideAddButton: false,
		addDisabled: false,
		addDisabledReason: "",
		addActions: [],
		addDropdownButton: null // { labelKey, variant, options: [{ labelKey, icon, key, value }] }
	},
	additionalButtons = [],
) => {
	const filterItems = [
		{
			type: "search",
			key: "search",
			labelKey: "filter-bar.search",
			value: "",
		},
		...additionalButtons,
	];

	// Add any additional action buttons
	if (config?.addActions && Array.isArray(config.addActions)) {
		config.addActions.forEach(action => {
			filterItems.push({
				type: "button",
				key: action.key,
				labelKey: action.label,
				className: `filter-bar-btn btn btn-${action.variant || 'primary'}`,
				variant: action.variant || 'primary',
				displayPosition: "right"
			});
		});
	}

	// Add dropdown button if configured
	if (config?.addDropdownButton) {
		filterItems.push({
			type: "dropdownButton",
			key: config.addDropdownButton.key || "add",
			labelKey: config.addDropdownButton.labelKey || "filter-bar.add",
			variant: config.addDropdownButton.variant || "success",
			options: config.addDropdownButton.options || [],
			disabled: config.addDropdownButton.disabled || false,
			displayPosition: "right"
		});
	}
	// Otherwise, add regular "add" button if hideAddButton is false
	else if (!config?.hideAddButton) {
		filterItems.push({
			type: "button",
			key: "add",
			labelKey: config?.addTextKey || "filter-bar.add",
			disabled: config?.addDisabled || false,
			disabledReason: config?.addDisabledReason || "",
			displayPosition: "right"
		});
	}
	return filterItems;
};

export { getSearchAddFilter };
